import Footer from '../components/Footer';

export default function Impressum() {
  return (
    <>
    <div className="min-h-screen bg-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Impressum</h1>

        <div className="prose prose-lg max-w-none">
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Angaben gemäß § 5 TMG</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Christel Media Marketing GmbH<br />
            Immermannstraße 34<br />
            40210 Düsseldorf
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Vertreten durch</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Geschäftsführer: Christoph El-Fallah
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Registereintrag</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Eintragung im Handelsregister<br />
            Registergericht: Amtsgericht Düsseldorf<br />
            Registernummer: HRB 102006
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Umsatzsteuer-Identifikationsnummer</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            DE366298821
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Kontakt</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            E-Mail: info@christel-media.de
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Christoph El-Fallah<br />
            Immermannstraße 34<br />
            40210 Düsseldorf
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">EU-Streitschlichtung</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700 underline ml-1">
              https://ec.europa.eu/consumers/odr/
            </a>.<br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Haftung für Inhalte</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6">
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Haftung für Links</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6">
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Urheberrecht</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6">
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}
